import React, { useState } from "react";
import {
  useAddFeaturedMutation,
  useDeleteFeaturedMutation,
  useFeaturedsQuery,
  useGetAllProductsQuery,
} from "../../service/featuredApi";
import { toast } from "react-toastify";
const ManageFeatured = () => {
  const [searchText, setSearchText] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const { data } = useGetAllProductsQuery();
  const { data: featured } = useFeaturedsQuery();
  const [addFeatured] = useAddFeaturedMutation();
  const [deleteFeatured] = useDeleteFeaturedMutation();

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (searchText) {
      const filtered = data?.data?.filter(
        (d) =>
          d?.name
            ?.split(" ")
            .join("")
            ?.toLowerCase()
            .includes(e.target.value?.toLowerCase()) ||
          d?.brand
            ?.split(" ")
            .join("")
            ?.toLowerCase()
            .includes(e.target.value?.toLowerCase())
      );
      setSearchResult(filtered);
    }
  };

  const handleAddFeatured = (id) => {
    const data = {
      productId: id,
    };
    addFeatured(data).then((res) => {
      if (res?.data?.status) {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      }
    });
  };

  const handleRemove = (id) => {
    deleteFeatured(id).then((res) => {
      if (res?.data?.status) {
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      }
    });
  };

  return (
    <div className="container mx-auto">
      <div className="bg-gray-700 my-[20px] rounded p-[20px]">
        <h3 className="text-start text-[20px] font-bold text-white mb-[20px]">
          Featured Products
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[20px]">
          {featured?.data?.length > 0 ? (
            <>
              {featured?.data?.map((card) => (
                <div
                  className="mx-auto cursor-pointer w-[100%] rounded-sm bg-black"
                  key={card?._id}
                >
                  <div className="bg-black card-shadow h-[270px] lg:h-[490px] w-[100%] relative  rounded-sm">
                    <div className="overflow-hidden">
                      <img
                        src={card?.productId?.images[0]}
                        alt={card?.productId?.name}
                        className="w-full h-[120px] lg:h-[240px] 2xl:h-[310px] object-contain"
                      />
                    </div>
                    <div className="p-3 text-sm lg:p-4 text-start ">
                      <h2 className="font-semibold text-gray-600 text-[14px] lg:text-[18px] ">
                        {card?.productId?.name}
                      </h2>
                      <p className="font-medium text-[12px] text-gray-600 lg:text-[15px] my-[7px] mb-[15px]">
                        {card?.productId?.brand}
                      </p>
                      <p className="font-semibold text-gray-600 text-[16px] absolute bottom-[13px]">
                        £{parseFloat(card?.productId?.price).toFixed(2)}
                      </p>
                      <button
                        onClick={() => handleRemove(card?._id)}
                        className="bg-[#b82f2f] text-white font-semibold px-[15px] py-[7px] rounded"
                      >
                        Remove from Featured
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <>
              <h3 className="text-center text-[20px] font-bold text-white mb-[20px]">
                No Product as featured!
              </h3>
            </>
          )}
        </div>
      </div>

      <div className="bg-gray-700 my-[20px] rounded p-[20px]">
        <h3 className="text-start text-[20px] font-bold text-white mb-[20px]">
          All Products
        </h3>
        <div className="mb-[20px]">
          <input
            onChange={handleChange}
            placeholder="Please search by product name or brand"
            className="w-[100%] bg-black text-[18px] text-white border-[1px] border-[black] outline-none focus:outline-none px-[10px] py-[7px]"
          />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[20px]">
          {searchText ? (
            <>
              {searchResult?.length > 0 ? (
                <>
                  {searchResult?.map((card) => (
                    <div
                      className="mx-auto cursor-pointer w-[100%] rounded-sm bg-black"
                      key={card?._id}
                    >
                      <div className="bg-black card-shadow h-[270px] lg:h-[490px] w-[100%] relative  rounded-sm">
                        <div className="overflow-hidden">
                          <img
                            src={card?.images[0]}
                            alt={card?.name}
                            className="w-full h-[120px] lg:h-[240px] 2xl:h-[310px] object-contain"
                          />
                        </div>
                        <div className="p-3 text-sm lg:p-4 text-start ">
                          <h2 className="font-semibold text-gray-600 text-[14px] lg:text-[18px] ">
                            {card?.name}
                          </h2>
                          <p className="font-medium text-[12px] text-gray-600 lg:text-[15px] my-[7px] mb-[15px]">
                            {card?.brand}
                          </p>
                          <p className="font-semibold text-gray-600 text-[16px] absolute bottom-[13px]">
                            £{parseFloat(card?.price).toFixed(2)}
                          </p>
                          <button
                            onClick={() => handleAddFeatured(card?._id)}
                            className="bg-[#196850] text-white font-semibold px-[15px] py-[7px] rounded"
                          >
                            Add to Featured
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  <h3 className="text-center text-[20px] font-bold text-white mb-[20px]">
                    No Product Found!
                  </h3>
                </>
              )}
            </>
          ) : (
            <>
              {data?.data?.map((card) => (
                <div
                  className="mx-auto cursor-pointer w-[100%] rounded-sm bg-black"
                  key={card?._id}
                >
                  <div className="bg-black card-shadow h-[270px] lg:h-[490px] w-[100%] relative  rounded-sm">
                    <div className="overflow-hidden">
                      <img
                        src={card?.images[0]}
                        alt={card?.name}
                        className="w-full h-[120px] lg:h-[240px] 2xl:h-[310px] object-contain"
                      />
                    </div>
                    <div className="p-3 text-sm lg:p-4 text-start ">
                      <h2 className="font-semibold text-gray-600 text-[14px] lg:text-[18px] ">
                        {card?.name}
                      </h2>
                      <p className="font-medium text-[12px] text-gray-600 lg:text-[15px] my-[7px] mb-[15px]">
                        {card?.brand}
                      </p>
                      <p className="font-semibold text-gray-600 text-[16px] absolute bottom-[13px]">
                        £{parseFloat(card?.price).toFixed(2)}
                      </p>
                      <button
                        onClick={() => handleAddFeatured(card?._id)}
                        className="bg-[#196850] text-white font-semibold px-[15px] py-[7px] rounded"
                      >
                        Add to Featured
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageFeatured;
